'use strict';
declare var sharedWatchListConfig: any;

module Patersons {

    export interface WatchlistSALScope extends ng.IScope {

        events: AbstractController;

        name: string;

        watchlistId: number;
        relatedWatchlist: Watchlist;
    }

    export class WatchlistItemCtrl extends AnalysisBaseCtrl {
        scope: Patersons.WatchlistSALScope;
        analysisService: Patersons.AnalysisService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'analysisService', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, analysisService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.analysisService = analysisService;

            this.scope.watchlistId = $stateParams['watchlistId'];

            this.load();
        }
        showAllWatchlists(){
            this.state.go("watchlist", {}, {reload: true});
        }
        load() {
            let tickers = [];
            if (this.state.params['watchlistId']) {
                this.analysisService.getAWatchlist(this.state.params['watchlistId'])
                .then((watchlist: Watchlist) => {
                    this.scope.relatedWatchlist = watchlist;
                    this.scope.name = watchlist.name;
                    var unique = watchlist.watchlistItems.filter(function (elem, index, self) {
                        return index == self.indexOf(elem);
                    })
                    watchlist.watchlistItems = unique;
                    tickers = watchlist.watchlistItems;
                    this.initializeMorningstar(tickers);
                }).catch(err => {
                    this.state.go('watchlist')
                    alert('Watchlist not found.')
                })
            } else if (this.state.params['secIds']) {
                tickers = this.state.params['secIds'].split("|");
                this.initializeMorningstar(tickers);
            } else {
                this.state.go("watchlist");
            }
        }
        updateWatchlistFromTickers(tickers: string[]) {
            this.scope.relatedWatchlist.watchlistItems = tickers.map(function (item) {
                return item;
            })
            var unique = this.scope.relatedWatchlist.watchlistItems.filter(function (elem, index, self) {
                return index == self.indexOf(elem);
            })
            this.scope.relatedWatchlist.watchlistItems = unique;
            return this.analysisService.patchWatchlist(this.scope.relatedWatchlist);
        }
        openAsHeatmap(){
            if (this.scope.watchlistId){
                window.open(this.state.href("heatmap", { watchlistId: this.scope.watchlistId }), "_parent")
                // this.state.go("heatmap", {watchlistId: this.scope.watchlistId}, {reload: true});
            }
        }
        initializeMorningstar(tickers) {
            let self = this;

            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');

                    initComponent('component-watchlist', 'ecWatchList-container', 'ec-watch-list', 'ecWatchList').then(function () {

                        var watchlistInstance = morningstar.asterix.instanceRegistry.get('ecWatchList');
                        //set default watchlist items
                        watchlistInstance.setParameter('tickers', tickers);
                        initComponent('component-autocomp-watchlist', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteWatchlist').then(function () {

                            //connect watchlist to autocomplete search
                            morningstar.asterix.instanceRegistry.find('ecAutocompleteWatchlist').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                                let tickersTemp = morningstar.asterix.instanceRegistry.get('ecWatchList').getParameter('tickers');

                                //make sure there is no duplicate
                                if (newVal.secId && !tickersTemp.includes(newVal.secId)) {
                                    tickersTemp.push(newVal.secId);
                                    morningstar.asterix.instanceRegistry.get('ecWatchList').setParameter('tickers', tickersTemp);
                                    self.updateWatchlistFromTickers(morningstar.asterix.instanceRegistry.get('ecWatchList').getParameter('tickers'));
                                    morningstar.asterix.instanceRegistry.get('ecAutocompleteWatchlist').setParameter('search', '');
                                }
                            });
                            morningstar.asterix.instanceRegistry.get('ecWatchList.actionBar.actionRemove').on('click', function (event) {
                                event.preventDefault();
                                var watchlist = morningstar.asterix.instanceRegistry.find('ecWatchList');
                                var toBeRemove = watchlist.getParameter('selectedItemKeys');
                                var tempList = watchlist.getParameter('tickers').slice().filter(function (el) { return toBeRemove.indexOf(el) < 0; });
                                watchlist.setParameter('tickers', tempList);
                                self.updateWatchlistFromTickers(tempList).then(() => {
                                    if(tempList.length == 0){
                                        self.state.reload();
                                    }
                                })
                            });

                        });
                    });

            });

        }
    }


}
